import { PricingTierService } from '../../services/pricing-tier.service';
import { Component, OnInit } from '@angular/core';
import { ModalController, LoadingController, AlertController, Platform, NavParams } from '@ionic/angular';
import { AuthService } from '../../services/auth.service';
import { APIService } from '../../services/api.service';
import { Router } from '@angular/router';
import { CartService } from '../../services/cart.service';
import { CountryService } from '../../services/country.service';
import { ObserverService } from '../../services/observer.service';
import { OrganisationService } from '../../services/organisation.service';
import { CountryPickerPage } from './../../modals/country-picker/country-picker.page';
import { Capacitor } from '@capacitor/core';

@Component({
    selector: 'app-organisation-edit',
    templateUrl: './organisation-edit.page.html',
    styleUrls: ['./organisation-edit.page.scss'],
})

export class OrganisationEditPage implements OnInit {

    spinner = null;
    loading_spinner = null;
    loading = false;
    online = true;
    params = {};
    modal_css_class = '';
    organisation_id = null;
    organisation = null;
    pricing_tiers = null;
    mailing_address_country = null;
    billing_address_country = null;

    // modal flags
    country_picker_modal_open = false;

    constructor(
        public modalController: ModalController,
        public navParams: NavParams,
        public loadingController: LoadingController,
        public alertController: AlertController,
        private platform: Platform,
        private authService: AuthService,
        private apiService: APIService,
        private cartService: CartService,
        private router: Router,
        private countryService: CountryService,
        private observerService: ObserverService,
        private organisationService: OrganisationService,
        private pricingTierService: PricingTierService
    ) { }

    ngOnInit() {

        if(Capacitor.isNativePlatform()) {
            this.modal_css_class = 'fullscreen';
        }

        if(this.navParams.get("organisation_id")) {

            this.organisation_id = this.navParams.get("organisation_id");

            this.loadData().then(() => {

                this.params['title'] = this.organisation.title;
                this.params['allow_on_account_payment_method'] = this.organisation.allow_on_account_payment_method;
                this.params['pricing_tier_id'] = this.organisation.pricing_tier.id;
                this.params['internal_note'] = "";
                this.params["mailing_address_line_1"] = "";
                this.params["mailing_address_line_2"] = "";
                this.params["mailing_address_locality"] = "";
                this.params["mailing_address_subdivision"] = "";
                this.params["mailing_address_postal_code"] = "";
                this.params["mailing_address_country_id"] = "";
                this.params["billing_address_line_1"] = "";
                this.params["billing_address_line_2"] = "";
                this.params["billing_address_locality"] = "";
                this.params["billing_address_subdivision"] = "";
                this.params["billing_address_postal_code"] = "";
                this.params["billing_address_country_id"] = "";

                if(this.organisation.internal_note) {
                    this.params['internal_note'] = this.organisation.internal_note;
                }

                if(this.organisation.mailing_address) {
                    if(this.organisation.mailing_address.line_1) {
                        this.params["mailing_address_line_1"] = this.organisation.mailing_address.line_1;
                    }
                    if(this.organisation.mailing_address.line_2) {
                        this.params["mailing_address_line_2"] = this.organisation.mailing_address.line_2;
                    }
                    if(this.organisation.mailing_address.locality) {
                        this.params["mailing_address_locality"] = this.organisation.mailing_address.locality;
                    }
                    if(this.organisation.mailing_address.subdivision) {
                        this.params["mailing_address_subdivision"] = this.organisation.mailing_address.subdivision;
                    }
                    if(this.organisation.mailing_address.postal_code) {
                        this.params["mailing_address_postal_code"] = this.organisation.mailing_address.postal_code;
                    }
                    if(this.organisation.mailing_address.country) {
                        this.params["mailing_address_country_id"] = this.organisation.mailing_address.country.id;
                        this.countryService.getCountry(this.organisation.mailing_address.country.id).then((country) => {
                            if(country) {
                                this.mailing_address_country = country;
                            }
                        })
                        .catch(() => { });
                    }
                }

                if(this.organisation.billing_address) {
                    if(this.organisation.billing_address.line_1) {
                        this.params["billing_address_line_1"] = this.organisation.billing_address.line_1;
                    }
                    if(this.organisation.billing_address.line_2) {
                        this.params["billing_address_line_2"] = this.organisation.billing_address.line_2;
                    }
                    if(this.organisation.billing_address.locality) {
                        this.params["billing_address_locality"] = this.organisation.billing_address.locality;
                    }
                    if(this.organisation.billing_address.subdivision) {
                        this.params["billing_address_subdivision"] = this.organisation.billing_address.subdivision;
                    }
                    if(this.organisation.billing_address.postal_code) {
                        this.params["billing_address_postal_code"] = this.organisation.billing_address.postal_code;
                    }
                    if(this.organisation.billing_address.country) {
                        this.params["billing_address_country_id"] = this.organisation.billing_address.country.id;
                        this.countryService.getCountry(this.organisation.billing_address.country.id).then((country) => {
                            if(country) {
                                this.billing_address_country = country;
                            }
                        })
                        .catch(() => { });
                    }
                }

            })
            .catch(() => { });

        }

        this.observerService.subscribe('pricing_tier_added|organisation_edit_modal', (pricing_tier) => {
            if(pricing_tier) {
                let pricing_tiers = this.pricing_tiers;
                pricing_tiers.push(pricing_tier);
                this.sortPricingTiers(pricing_tiers);
            }
        });

        this.observerService.subscribe('pricing_tier_deleted|organisation_edit_modal', (pricing_tier) => {
            if(pricing_tier) {
                let pricing_tiers = this.pricing_tiers;
                for(let i = 0; i < pricing_tiers.length; i++) {
                    if(pricing_tiers[i].id === pricing_tier["id"]) {
                        pricing_tiers.splice(i, 1);
                        break;
                    }
                }
                this.sortPricingTiers(pricing_tiers);
            }
        });

        this.observerService.subscribe('pricing_tier_updated|organisation_edit_modal', (pricing_tier) => {
            if(pricing_tier) {
                let pricing_tiers = this.pricing_tiers;
                for(let i = 0; i < pricing_tiers.length; i++) {
                    if(pricing_tiers[i].id === pricing_tier["id"]) {
                        pricing_tiers[i] = pricing_tier;
                        break;
                    }
                }
                this.sortPricingTiers(pricing_tiers);
            }
        });

        this.observerService.subscribe('pricing_tiers_changed|organisation_edit_modal', (pricing_tiers) => {
            if(pricing_tiers) {
                this.sortPricingTiers(pricing_tiers);
            }
        });

        this.observerService.subscribe('network_status_changed|organisation_edit_modal', (network_status) => {
            if(network_status) {
                this.online = network_status.connected;
                if(this.online) {
                    this.loadData().then(() => {} ).catch(() => { });
                }
                else {
                    this.presentAlert("Problem", "Offline", "You must be online to edit an organisation, please check your network connection and try again.");
                }
            }
        });

    }

    ngOnDestroy() {
        this.observerService.destroy("pricing_tier_added|organisation_edit_modal");
        this.observerService.destroy("pricing_tier_updated|organisation_edit_modal");
		this.observerService.destroy("pricing_tier_deleted|organisation_edit_modal");
        this.observerService.destroy("pricing_tiers_changed|organisation_edit_modal");
        this.observerService.destroy("network_status_changed|organisation_edit_modal");
    }

    loadData() {
        return new Promise<void>((resolve, reject) => {
            this.presentLoadingSpinner("Loading organisation").then(() => {
                this.loadOrganisation().then(() => {
                    this.loading_spinner.message = "Loading pricing tiers";
                    this.pricingTierService.getPricingTiers().then((pricing_tiers) => {
                        if(pricing_tiers) {
                            this.sortPricingTiers(pricing_tiers);
                        }
                        this.loading_spinner.dismiss();
                        resolve();
                    })
                    .catch(() => {
                        this.loading_spinner.dismiss();
                        reject();
                    });
                })
                .catch(() => {
                    this.loading_spinner.dismiss();
                    reject();
                });
            });
        });
    }

    loadOrganisation() {
        return new Promise<void>((resolve, reject) => {
            this.organisation = null;
            this.authService.isLoggedIn().then(() => {
                this.apiService.getOrganisation(this.organisation_id).then((organisation: any) => {
                    if(organisation) {
                        this.organisation = organisation;
                    }
                    resolve();
                })
                .catch((error) => {
                    this.organisation = {};
                    if(error.status == 400) {
                        this.presentAlert("Problem", "Unknown error", "Unfortunately something went wrong when trying to retrieve an organisation.");
                    }
                    else if(error.status == 403) {
                        this.presentAlert("Problem", "Insufficient permissions", "You don't have permission to view an organisation.");
                    }
                    else if(error.status == 404 || error.status == 0) {
                        this.presentAlert("Problem", "Unavailable", "Unfortunately we're unable to retrieve an organisation at this time.");
                    }
                    reject();
                });
            })
            .catch(() => {
                this.router.navigate(["switch-account"], { replaceUrl: true }).then(() => {
                    window.location.reload();
                });
            });
        });
    }

    close() {
        this.modalController.dismiss();
    }

    sortPricingTiers(pricing_tiers) {
        pricing_tiers.sort((a, b) => {
            if(a['order'] < b['order']) { return -1; }
            if(a['order'] > b['order']) { return 1; }
            return 0;
        });
        this.pricing_tiers = pricing_tiers;
    }

    update() {

        let validated = true;

        if(this.params['title'] == null || this.params['title'].trim() === "") {
            this.presentAlert("Problem", "Title required", "Please enter a title");
            validated = false;
        }

        if(validated) {
            this.updateOrganisation().then(() => {
                this.modalController.dismiss();
            });
        }

    }

    updateOrganisation() {
        return new Promise<void>((resolve, reject) => {
            this.presentSpinner("Updating organisation").then(() => {
                this.authService.isLoggedIn().then(() => {
                    this.apiService.updateOrganisation(this.organisation_id, this.params).then((organisation) => {
                        if(organisation) {
                            this.organisationService.updateOrganisation(this.organisation).then(() => {
                                this.cartService.get().then((cart) => {
                                    if(cart['organisation']) {
                                        if(cart['organisation'].id == this.organisation.id) {
                                            this.cartService.updateOrganisation(this.organisation['id']).then(() => {}).catch(() => {});
                                        }
                                    }
                                })
                                .catch(() => { });
                            })
                            .catch(() => { });
                        }
                        this.spinner.dismiss();
                        resolve();
                    })
                    .catch((error) => {
                        if(error) {
                            if(error.status === 400) {
                                this.presentAlert("Problem", "Unknown error", "Unfortunately something went wrong when trying to update this organisation.");
                            }
                            else if(error.status === 403) {
                                this.presentAlert("Problem", "Insufficient permissions", "You don't have permission to update this organisation.");
                            }
                            else if(error.status === 404 || error.status === 0) {
                                this.presentAlert("Problem", "Unavailable", "Unfortunately we're unable to update this organisation at this time.");
                            }
                        }
                        this.spinner.dismiss();
                        reject();
                    });
                })
                .catch(() => {
                    this.router.navigate(["switch-account"], { replaceUrl: true }).then(() => {
                        window.location.reload();
                    });
                });
            });
        });
    }

    async presentMailingAddressCountryPickerModal() {
        if(!this.country_picker_modal_open) {
            this.country_picker_modal_open = true;
            const modal = await this.modalController.create({
                component: CountryPickerPage,
                cssClass: this.modal_css_class,
                componentProps: {
                    country_id: (this.params['mailing_address_country_id'] ? this.params['mailing_address_country_id'] : "")
                }
            });
            modal.onDidDismiss().then((data) => {
                this.country_picker_modal_open = false;
                if(data.data) {
                    if(data.data === "country_deleted") {
                        this.params["mailing_address_country_id"] = "";
                        this.mailing_address_country = null;
                    } 
                    else {
                        this.params["mailing_address_country_id"] = data.data['country_id'];
                        this.countryService.getCountry(data.data['country_id']).then((country) => {
                            if(country) {
                                this.mailing_address_country = country;
                            }
                        })
                        .catch(() => { });
                    }
                }
            });
            return await modal.present();
        }
        else {
            return null;
        }
    }

    async presentBillingAddressCountryPickerModal() {
        if(!this.country_picker_modal_open) {
            this.country_picker_modal_open = true;
            const modal = await this.modalController.create({
                component: CountryPickerPage,
                cssClass: this.modal_css_class,
                componentProps: {
                    country_id: (this.params['billing_address_country_id'] ? this.params['billing_address_country_id'] : "")
                }
            });
            modal.onDidDismiss().then((data) => {
                this.country_picker_modal_open = false;
                if(data.data) {
                    if(data.data === "country_deleted") {
                        this.params["billing_address_country_id"] = "";
                        this.billing_address_country = null;
                    } 
                    else {
                        this.params["billing_address_country_id"] = data.data['country_id'];
                        this.countryService.getCountry(data.data['country_id']).then((country) => {
                            if(country) {
                                this.billing_address_country = country;
                            }
                        })
                        .catch(() => { });
                    }
                }
            });
            return await modal.present();
        }
        else {
            return null;
        }
    }

    async presentAlert(header, sub_header, message) {
        const alert = await this.alertController.create({
            header: header,
            subHeader: sub_header,
            message: message,
            buttons: ["OK"],
        });
        await alert.present();
    }

    async presentSpinner(message) {
        this.spinner = await this.loadingController.create({
            message: message,
            showBackdrop: false,
            cssClass: 'loading-spinner'
        });
        await this.spinner.present();
    }

    async presentLoadingSpinner(message) {
        this.loading = true;
        this.loading_spinner = await this.loadingController.create({
            message: message,
            showBackdrop: false,
            cssClass: 'loading-spinner'
        });
        this.loading_spinner.onDidDismiss().then(() => {
            this.loading = false;
        });
        await this.loading_spinner.present();
    }

}